export const dataList = [
    {
        name: '小程序用户数',
        num: 0
    }, {
        name: '主办方数',
        num: 0
    }, {
        name: '票品收入（元）',
        num: 0
    }, {
        name: '票品服务费（元）',
        num: 0
    }
]
export const dataList2 = [
    {
        name: '赛事（场）',
        num: 0
    }, {
        name: '大师课数（场）',
        num: 0
    }, {
        name: '演出活动（场）',
        num: 0
    }, {
        name: '累计收益（元）',
        num: 0
    }, {
        name: '待结算（元）',
        num: 0
    }, {
        name: '可提现（元）',
        num: 0
    }
]
export const functionData = [
    {
        title: '活动审核',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375566150294.png',
        path: 'audit',
        url: 'audit/activity',
        isAuthority: false
    }, {
        title: '创建活动',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375534231583.png',
        path: '/activity/add_activity',
        url: 'activity/list',
        isAuthority: false,
    }, {
        title: '提现审核',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375616806127.png',
        path: '/audit/withdraw',
        url: 'audit/withdraw',
        isAuthority: false
    }
]
export const functionData2 = [
    {
        title: '创建活动',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375534231583.png',
        path: '/activity/sponsor_add',
        url: 'activity/sponsor',
        isAuthority: false,
    }, {
        title: '收入提现',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375566150294.png',
        path: '/finance/property',
        url: 'propertyDetailed',
        isAuthority: false
    }, {
        title: '订单管理',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375616806127.png',
        path: 'activity/ticket_order',
        url: 'activity/ticket_order',
        isAuthority: false
    }, {
        title: '已售票管理',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375566150294.png',
        path: 'activity/verification',
        url: 'activity/verification',
        isAuthority: false
    }, {
        title: '核销助手',
        icon: 'https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/19/1608375566150294.png',
        path: 'application/applied',
        url: 'application/applied',
        isAuthority: false
    }
]